import React from 'react';

const NewsletterAndFeaturesSection = () => {
  return (
    <>
      {/* Newsletter Section */}
      <section className="section-blue small-paddings" id="newsletter-section">
        <div className="container">
          <div className="row">
            {/* Title Section */}
            <div className="col-md-12 text-center padding-bottom-20">
              <h1 className="white-text">Make an Application for your Business</h1>
            </div>

            {/* Description Section */}
            <div className="col-md-12 text-center padding-bottom-20">
              <h3 className="white-text">
                Now more than ever an Application is essential for your business. Your web & mobile app is your
                unique identity in the global world. Customize it with your logo, colors, products & content.
              </h3>
            </div>

            {/* Button Section */}
            <div className="col-md-12">
              <div
                className="newsletter_form_wrapper wow bounceIn"
                data-wow-delay="0.2s"
                style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'bounceIn' }}
              >
                <a href="#pricing" className="btn-blue scrool">
                  Get Started
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="section-white section-top-border">
        <div className="container">
          <div className="row">
            <div className="col-md-6 padding-top-30">
              {/* Feature 1 */}
              <div className="features-second">
                <div className="dropcaps-circle">
                  <i className="fas fa-chart-line"></i>
                </div>
                <h4 className="margin-bottom-5 ft-size-25">Build your Website and Mobile Applications.</h4>
                <p>Create your own website and mobile apps with ease and flexibility.</p>
              </div>

              {/* Feature 2 */}
              <div className="features-second">
                <div className="dropcaps-circle">
                  <i className="fas fa-network-wired"></i>
                </div>
                <h4 className="margin-bottom-5 ft-size-25">Easy onboarding, fast adoption.</h4>
                <p>With InstaApp getting your team on board is as simple as sending an email.</p>
              </div>

              {/* Feature 3 */}
              <div className="features-second">
                <div className="dropcaps-circle">
                  <i className="fas fa-rocket"></i>
                </div>
                <h4 className="margin-bottom-5 ft-size-25">Grow your business with InstaApp.</h4>
                <p>InstaApp can help you grow your business by selling your products, and take payments through the user-friendly apps.</p>
              </div>
            </div>

            {/* Image Section */}
            <div className="col-md-6 wow slideInRight" data-wow-delay="0.05s" style={{ visibility: 'visible', animationDelay: '0.05s', animationName: 'slideInRight' }}>
              <img src="assets/images/img10.png" className="width-100 box-shadow" alt="pic" />
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose InstaApp Section */}
      <section className="section-blue">
        <div className="container">
          <div className="row">
            {/* Why Choose InstaApp Text */}
            <div className="col-md-12 padding-top-25 padding-left-20">
              <h2 className="white-text">Why choose InstaApp?</h2>
              <p className="white-text">
                <b>Expertise and Experience:</b>
                <br />
                <span className="p15">Trusted team with extensive web and mobile app development experience.</span>
              </p>
              <p className="white-text">
                <b>Customized Solutions:</b>
                <br />
                <span className="p15">Tailored applications to meet your unique business requirements.</span>
              </p>
              <p className="white-text">
                <b>Quality and Reliability:</b>
                <br />
                <span className="p15">Commitment to delivering top-quality, robust, and secure applications.</span>
              </p>
              <p className="white-text">
                <b>Ongoing Support:</b>
                <br />
                <span className="p15">Comprehensive support and maintenance services for long-term success.</span>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NewsletterAndFeaturesSection;
